import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { CustomTableReportEquipmentLogbook } from 'src/app/interfaces/custom-table-report-equipment-logbook/custom-table-report-equipment-logbook.interface';
import { MaintenanceReportFilterModel } from 'src/app/models/maintenance/maintenance-report-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceReportService {

    private readonly _httpClient = inject(HttpClient);

    exportMaintenanceReportProgrammingDays(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<Blob> {
        return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.ExportMaintenanceReportProgrammingDays}`, maintenanceReportFilter, {
            responseType: 'blob',
        });
    }

    getMaintenanceReportProgrammingDays(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<CustomTableReport> {
        return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.MaintenanceReportProgrammingDays}`, maintenanceReportFilter);
    }

    exportMaintenanceCostsForEquipment(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<Blob> {
        return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.ExportMaintenanceCostsForEquipment}`, maintenanceReportFilter, {
            responseType: 'blob',
        });
    }

    getMaintenanceCostsForEquipment(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<CustomTableReport> {
        return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.MaintenanceCostsForEquipment}`, maintenanceReportFilter);
    }

    exportRepairHistory(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<Blob> {
        return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.ExportRepairHistory}`, maintenanceReportFilter, {
            responseType: 'blob',
        });
    }

    getRepairHistory(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<CustomTableReport> {
        return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.RepairHistory}`, maintenanceReportFilter);
    }

    exportSimpleEquipmentLogbook(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<Blob> {
        return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.ExportSimpleEquipmentLogbook}`, maintenanceReportFilter, {
            responseType: 'blob',
        });
    }

    getSimpleEquipmentLogbook(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<CustomTableReportEquipmentLogbook> {
        return this._httpClient.post<CustomTableReportEquipmentLogbook>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.SimpleEquipmentLogbook}`, maintenanceReportFilter);
    }

    exportValuedEquipmentLogbook(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<Blob> {
        return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.ExportValuedEquipmentLogbook}`, maintenanceReportFilter, {
            responseType: 'blob',
        });
    }

    getValuedEquipmentLogbook(maintenanceReportFilter: MaintenanceReportFilterModel): Observable<CustomTableReportEquipmentLogbook> {
        return this._httpClient.post<CustomTableReportEquipmentLogbook>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceReport.ValuedEquipmentLogbook}`, maintenanceReportFilter);
    }
}